import Admin from 'hive-admin';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
  SELLER as FIELDS_SELLER,
} from './fields';

import copyToClipboard from '../../helpers/copyToClipboard';

import { getI18nFields } from '../../helpers/i18n';

import tests from '../../helpers/tests';

// import Types from '../../modules/types';

const {
  viewerIsNotAdmin,
  viewerIsNotThehiveRsAdmin,
} = tests;

export default [
  ['ADMIN', {
    path: '/products-imports',
  }],
  // ['SELLER', {
  //   path: '/store/products-imports',
  //   archiveLoadUrl: '/products-imports',
  // }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_SELLER]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Product Imports',
      // icon: 'upload',
      skip: [
        viewerIsNotAdmin,
      ],
      archiveConfig: {
        title: 'Product Imports',
        label: 'Product Imports',
        // icon: 'upload',
        createButtonSupported: false,
        hidden: [
          viewerIsNotAdmin,
          // [
          //   'condition.checkViewer',
          //   'role', '!==', forRole,
          // ],
        ],
        createButtonPath: `${config.path}/create`,
      },
      singleLoadUrl: `/products-imports/:id/?${
        [
          'includeStoreData=true',
          'includeGalleryInfo=true',
        ].join('&')
      }`,
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        title: 'Products Import',
        getPageFields: getI18nFields,
      },
      singleEditConfig: {
        actions: [
          ['ActionSave', {
            handleSuccess: (data, props) => props.reload(),
            skip: [
              viewerIsNotThehiveRsAdmin,
              props => !['NEW', 'DONE'].includes(
                props.data.status,
              ),
            ],
          }],
          ['ActionDelete', {
            skip: [
              viewerIsNotThehiveRsAdmin,
              props => !['NEW', 'DONE'].includes(
                props.data.status,
              ),
            ],
          }],
          // ['ActionWithRequest', {
          //   name: 'test-generate-gallery-sort',
          //   title: 'Generate Gallery Sort',
          //   // skip: [props => !['IMPORTING'].includes(
          //   //   props.data.status,
          //   // )],
          //   getRequestConfig: props => ({
          //     url: `products-imports/${
          //       props.data._id
          //     }/gallery/sort`,
          //     // data: props.form.getFieldsValue(),
          //     method: 'POST',
          //   }),
          //   handleSuccess: (data, props) => props.reload(),
          // }],
          // ['ActionWithRequest', {
          //   name: 'test-generate-products',
          //   title: 'Generate Products',
          //   // skip: [props => !['IMPORTING'].includes(
          //   //   props.data.status,
          //   // )],
          //   getRequestConfig: props => ({
          //     url: `products-imports/${
          //       props.data._id
          //     }/generate/products`,
          //     // data: props.form.getFieldsValue(),
          //     method: 'POST',
          //   }),
          //   handleSuccess: (data, props) => props.reload(),
          // }],
          ['ActionWithRequest', {
            name: 'start',
            title: 'Start',
            skip: [props => !['NEW', 'DONE'].includes(
              props.data.status,
            )],
            getRequestConfig: props => ({
              url: `products-imports/${
                props.data._id
              }/start`,
              // data: props.form.getFieldsValue(),
              method: 'POST',
            }),
            messageSuccess: 'Starting in a couple of seconds!',
            handleSuccess: (data, props) => props.reload(),
          }],
          ...[
            3,
            5,
            10,
          ].map(limit => ['ActionWithRequest', {
            name: `start-first-${limit}`,
            title: `Start First ${limit}`,
            skip: [props => !['NEW', 'DONE'].includes(
              props.data.status,
            )],
            getRequestConfig: props => ({
              url: `products-imports/${
                props.data._id
              }/start?limit=${limit}`,
              // data: props.form.getFieldsValue(),
              method: 'POST',
            }),
            messageSuccess: 'Starting in a couple of seconds!',
            handleSuccess: (data, props) => props.reload(),
          }]),
          ['ActionWithRequest', {
            name: 'stop',
            title: 'Stop',
            skip: [props => !['READY', 'IMPORTING'].includes(
              props.data.status,
            )],
            getRequestConfig: props => ({
              url: `products-imports/${
                props.data._id
              }/stop`,
              // data: props.form.getFieldsValue(),
              method: 'POST',
            }),
            messageSuccess: 'Stopping, may take a couple of seconds!',
            handleSuccess: (data, props) => props.reload(),
          }],
          // ['ActionWithRequest', {
          //   name: 'gallery-start',
          //   title: 'Start Gallery',
          //   skip: [props => !['NEW', 'DONE'].includes(props.data.status)],
          //   getRequestConfig: props => ({
          //     url: `products-imports/${
          //       props.data._id
          //     }/generate/gallery/start`,
          //     method: 'POST',
          //   }),
          //   messageSuccess: 'Starting in a couple of seconds!',
          //   handleSuccess: (data, props) => props.reload(),
          // }],
          // ['ActionWithRequest', {
          //   name: 'reset',
          //   title: 'Reset',
          //   skip: [props => ['IMPORTING'].includes(
          //     props.data.status,
          //   )],
          //   getRequestConfig: props => ({
          //     url: `products-imports/${
          //       props.data._id
          //     }/reset`,
          //     method: 'POST',
          //   }),
          //   messageSuccess: 'Reset Success!',
          //   handleSuccess: (data, props) => props.reload(),
          // }],
          // ['ActionWithRequest', {
          //   name: 'reset-gallery',
          //   title: 'Reset Gallery',
          //   skip: [props => ['IMPORTING'].includes(
          //     props.data.status,
          //   )],
          //   getRequestConfig: props => ({
          //     url: `products-imports/${
          //       props.data._id
          //     }/reset/gallery`,
          //     method: 'POST',
          //   }),
          //   messageSuccess: 'Reset Gallery Success!',
          //   handleSuccess: (data, props) => props.reload(),
          // }],
          ['ActionWithRequest', {
            name: 'delete-products',
            title: 'Delete Imported Products',
            skip: [props => !['NEW', 'DONE'].includes(
              props.data.status,
            )],
            getRequestConfig: props => ({
              url: `products-imports/${
                props.data._id
              }/delete-products`,
              method: 'POST',
            }),
            messageSuccess: 'Products Deleted!',
            handleSuccess: (data, props) => props.reload(),
          }],
          ['Action', {
            id: 'action-products-import-copy-to-clipboard',
            title: 'Copy To Clipboard',
            ghost: true,
            onClick: (props) => {
              copyToClipboard(JSON.stringify(props.data || null, null, '  '));
            },
          }],
        ],
      },
      redirect: [
        ['redirect.unauthorized'],
      ],
      columns: COLUMNS,
      filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
